import React, {Suspense, lazy}          from 'react'
import { BrowserRouter, Route, Switch } from 'react-router-dom'
import {FontAwesomeIcon}                from "@fortawesome/react-fontawesome"
import { faSpinner}                     from "@fortawesome/free-solid-svg-icons"

import client             from 'server/apollo'
import {AuthContext}      from 'routes/context'
import toast, { Toaster } from 'react-hot-toast'
import {useWindows} from 'resource/index'
const Home   = lazy(() => import('web/home/home'))
const Navbar = lazy(() => import('web/navbar/navbar'))
const Login  = lazy(() => import('web/login/login'))
const Sign   = lazy(() => import('web/sign/sign'))


const styles = {
    flex:{
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
        flexDirection: "column",
        height: "97vh"
    },
    icon:{
        color: "rgb(13, 74, 131)"
    }
}

const Routes = () => {
    const {get: dimension} = useWindows()
    const notify = {
        success: (message, icon, time) => toast.success(message, {icon: icon, duration: time ? time : 3000}),
        error:   (message, icon, time) => toast.error(message, message, {icon: icon, duration: time ? time : 3000}),
        remove:  () => toast.remove()
    }

    return (
        <AuthContext.Provider value={{notify, client, dimension}}>
            <Toaster
                position="top-right"
                reverseOrder={true}
            />
            <BrowserRouter>
                <Switch>
                    <Suspense fallback={
                        <div style={styles.flex}>
                            <FontAwesomeIcon icon={faSpinner} spin size="4x" style={styles.icon}/>
                        </div>
                        }>
                            <Route exact path="/"       render={() => <Home/>}/>
                            <Route exact path="/Sign"   render={() => <Sign/>}/>
                            <Route exact path="/Login"  render={() => <Login/>}/>
                            <Route path="/Dashboard"    render={() => <Navbar/>}/>
                    </Suspense>
                </Switch>
            </BrowserRouter>
        </AuthContext.Provider>
    )
}

export default Routes;